import {Tab} from '@headlessui/react';
import cx from 'classnames';

export interface Props {
  tabs: React.ReactElement[];
  panels: React.ReactElement[];
}

const BlogTabs = ({tabs: tabList, panels: tabPanels}: Props) => {
  return (
    <div className="w-full">
      <Tab.Group>
        <Tab.List className="flex space-x-1 rounded-xl pt-1">{tabList}</Tab.List>
        <Tab.Panels className="dark:bg-gray-900">
          {tabPanels.map((tabs, index) => (
            <Tab.Panel
              key={index}
              className={cx(
                'rounded-xl rounded-tl-none border-2 border-gray-200 p-5 text-black dark:border-gray-800 dark:bg-gray-900 dark:text-gray-300'
              )}
            >
              {tabs}
            </Tab.Panel>
          ))}
        </Tab.Panels>
      </Tab.Group>
    </div>
  );
};

BlogTabs.Tab = function BlogTab({children, className, selectedClassName}) {
  return (
    <Tab
      className={({selected}) =>
        cx(
          selected
            ? 'bg-gray-200 dark:bg-gray-800 dark:text-gray-300'
            : 'text-black dark:text-gray-300',
          'w-auto rounded-t-lg py-2.5 pl-6 pr-6 text-base font-medium leading-5 text-black',
          {
            [className]: className !== undefined && !selected,
            [selectedClassName]: selectedClassName !== undefined && selected,
          }
        )
      }
    >
      {children}
    </Tab>
  );
};

export default BlogTabs;
